import { AlertTriangle, CloudOff, X } from "lucide-react";

// Shared thumbnail strip for queued-offline / failed photos — used by every
// screen wired into the offline photo queue (lib/photoFlusher.js). Tapping a
// failed thumbnail retries it; the X always offers a discard (with confirm).
export function PendingPhotoThumbs({ pending, testId, onRetry, onDiscard }) {
    if (!pending || !pending.length) return null;

    return (
        <div className="flex flex-wrap gap-2 mt-2" data-testid={testId}>
            {pending.map((p) => (
                <div key={p.tempId} className="relative w-16 h-16">
                    <button type="button" onClick={() => p.failed && onRetry && onRetry(p.tempId)}
                        disabled={!p.failed || p.retrying}
                        data-testid={p.failed ? `pending-photo-failed-${p.tempId}` : `pending-photo-queued-${p.tempId}`}
                        className={`relative w-16 h-16 rounded-lg overflow-hidden border-2 ${p.failed ? "border-solid border-[#B3261E] cursor-pointer" : "border-dashed border-[#C9A66B] cursor-default"}`}
                        title={p.failed ? `Failed to upload: ${p.error || "server error"} — tap to retry` : "Saved on this device — will upload once you're back online"}>
                        <img src={p.previewUrl} alt={p.filename} className="w-full h-full object-cover opacity-60" />
                        <span className={`absolute bottom-0 inset-x-0 text-white text-[8px] font-semibold text-center py-0.5 flex items-center justify-center gap-0.5 ${p.failed ? "bg-[#B3261E]" : "bg-[#9F4212]"}`}>
                            {p.retrying ? "Retrying…" : p.failed ? <><AlertTriangle size={8} /> Retry</> : <><CloudOff size={8} /> Queued</>}
                        </span>
                    </button>
                    {onDiscard && (
                        <button type="button" data-testid={`pending-photo-discard-${p.tempId}`}
                            onClick={() => { if (window.confirm("Discard this photo? It will not be uploaded.")) onDiscard(p.tempId); }}
                            title="Discard this photo"
                            className="absolute -top-1.5 -right-1.5 w-5 h-5 grid place-items-center rounded-full bg-black/55 text-white hover:bg-[#B33A2E]">
                            <X size={11} />
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}
